export enum RetroreflectionTypeEnum {
  Unico = 'UNICO',
  Segmentado = 'SEGMENTADO',
};